'use client'

// React Imports
import {useRef, useEffect, useState} from 'react'

// Next Imports
import Link from 'next/link'

// MUI Imports
import IconButton from '@mui/material/IconButton'
import {useParams} from "next/navigation";
import {getLocalizedUrl} from "@/utils/i18n";
import type {Locale} from "@configs/i18n";
import {useSession} from "next-auth/react";
import Tooltip from "@mui/material/Tooltip";

const GoToHome = () => {
    const session = useSession({required: true})
    const [user, setUser]: any = useState(null)

    const {lang: locale}: any = useParams()
    const [text, setText] = useState('')

    useEffect(() => {
        if (session.status === 'authenticated') {
            const mySession: any = session.data

            setUser(mySession.user)

            if(locale){
                if(locale === 'it'){
                    setText(mySession.user.role >= 70 ? 'Home' : 'Pannello Amministratore' )
                }else{
                    setText(mySession.user.role >= 70 ? 'Home' : 'Admin Panel' )
                }
            }
        }
    }, [session.status]);

    const fornitoreId = typeof user?.fornitoreId === 'object'
        ? user?.fornitoreId?._id
        : user?.fornitoreId
    const href = user
        ? user.role < 70
            ? getLocalizedUrl('/PannelloAdmin', locale as Locale)
            : getLocalizedUrl(`/Home/${fornitoreId}`, locale as Locale)
        : '#'

    return (
        <>
            <Tooltip title={text}>
                <IconButton component={Link} href={href} className='text-textPrimary'>
                    <i className='tabler-home'/>
                </IconButton>
            </Tooltip>
        </>
    )
}

export default GoToHome
